/**
 * Allocate a Subscription for `channel` on the shared client, tolerating a stale one.
 *
 * A Centrifuge client that outlives its subscribers (a session-long singleton, or a client
 * reused across a component's remounts) throws `Subscription to the channel <channel> already
 * exists` from `client.newSubscription(channel)` whenever `getSubscription(channel)` is
 * non-null — and a subscription stays in that registry until `removeSubscription()` is called,
 * NOT merely `sub.unsubscribe()` (which only changes its state). So a page that unmounted
 * without removing its sub, or a fast remount, would otherwise crash the next mount. Clear any
 * lingering registry entry first, then allocate fresh. Pair every call with
 * {@link unsubscribeChannel} on cleanup.
 */
export function subscribeChannel(client, channel) {
    const stale = client.getSubscription(channel);
    if (stale)
        client.removeSubscription(stale);
    return client.newSubscription(channel);
}
/**
 * Tear down a channel subscription created by {@link subscribeChannel}.
 * `removeSubscription()` unsubscribes AND drops the sub from the client's internal registry,
 * so a later mount can re-subscribe to the same channel without a duplicate-subscription error.
 */
export function unsubscribeChannel(client, sub) {
    if (!sub)
        return;
    sub.removeAllListeners();
    client.removeSubscription(sub);
}
//# sourceMappingURL=subscription.js.map